var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st5{fill:#745075}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.8 29l7.9-2.3s11.8 10.1 25.6 8.8C173.2 34.2 184 28 184 28l12.7 3.1s-19.1 49.7-35.4 45.2C145 71.7 125.8 29 125.8 29z",
    fill: "#c61937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.8 70.7s.3 12.6 1.7 16.4c1.4 3.7 4 10.6 4 10.6l3.2 23.8h59.1l2.6-25.4s5.2-12.2 5.2-15.9V68.5c0-.9 0-1.8.1-2.7.6-6.1 3.5-29.3 6.2-33.4L184 28s-10.2 32.8-28.3 29c-18.1-3.8-21.9-30.3-21.9-30.3l-19.3 5.6c-.1 0 9.6 30.4 5.3 38.4z",
    fill: "#ff1900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 121.5h59.1s36 45.2 52.1 96.1c16.1 50.9 14.5 54.7 14.5 54.7s-43.3 21.8-79.6 13.8c-36.4-8-86.5 9.2-110.5-14.8 0-.1 35.8-121.2 64.4-149.8z",
    fill: "#ff1d3b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212 286c13-2.3 24.7-6.3 32.4-9.4-9.2-32.4-44.2-136.1-56.7-143.1.1.1 19.3 104.7 24.3 152.5zm-36.2-155.9s31 121.7 12.1 132.1c-19 10.3-12.1-132.1-12.1-132.1zM81.9 281.3c14.4 4.3 32.2 3.4 50.1 2.8-1.2-57.3 12.2-157.5 12.2-157.5-29.9 16.9-52.4 107.6-62.3 154.7zm76.6-151.2s-16.6 99.9-4.6 99.9c12.1 0 4.6-99.9 4.6-99.9zm-11.9-15c-15-7.5-19.3-61.1-27.9-84l-4.2 1.2s9.7 30.3 5.4 38.4c0 0 .3 12.6 1.7 16.4 1.4 3.7 4 10.6 4 10.6l3.2 23.8h59.1l.7-6.9c-6.9 2.6-28.9 7-42 .5z",
    opacity: 0.78,
    fill: "#c61937"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2 124.3c-17.1 0-28.1-1.3-30.6-2.4l.4-3c2 .8 13.2 2.4 30.3 2.4 17 0 29.4-2.2 30.4-2.4l-.1 3.1c-1.2.2-13.1 2.3-30.4 2.3z",
    fill: "#4b314c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162.7 122.7c0 .5-.1 1-.4 1.5h-4.6c-7-.2-12.1-1.1-14.5-2-.7-.3-1.1-1-.9-1.7.2-.8 1-1.3 1.8-1 2.3.7 7.1 1.6 13.6 1.7h4.6c.2.5.4 1 .4 1.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M162 124.2c-5 .2-14.2-.3-18.9-2-.7-.3-1.1-1-.9-1.7.2-.7.8-1.1 1.4-1.1.1 0 .3 0 .4.1 4.8 1.5 12.6 1.9 17.9 1.8 1 .8 1 1.9.1 2.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.2 124.2c-1.8 3-7.6 3-9.4 0h1.3c.8.7 2 1.2 3.4 1.2 2.3 0 3.3-1.1 3.4-1.2 2.6-2.9-3.4-5.8-6.6-3.1-.5 0-.9 0-1.4-.1.9-1.2 2.6-2 4.6-2 3.8.1 6.2 2.8 4.7 5.2z",
    fill: "#ffce00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.7 122.7c0 .2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4.4.2.4.4z",
    fill: "#3c233d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163 123.1h-.7c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h.7c.2 0 .4.2.4.4s-.2.4-.4.4z",
    fill: "#ffd15f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.4 122.7c0 .2-.2.3-.4.3h-1c.1.1.2.2.3.2h.7c.2-.1.4-.3.4-.5z",
    fill: "#ff875f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.9 120.1c2.8-1.2 5.3-.5 6.7.9.2.2-.1.6-.4.4-1.1-1.4-3.5-2.2-6.3-1.3zm0 5.6c2.8 1.1 5.3.5 6.7-.9.2-.2-.1-.6-.4-.3-1.1 1.3-3.4 2.1-6.3 1.2z",
    fill: "#fff983"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.2 63.1c-8.3 1.1-13.1 10.1-9.4 17.6.1.1.1.2.2.3 5.8 11 41.1 18.5 48.8 6.8 7.5-11.4 11.2-31.5-39.6-24.7z",
    opacity: 0.24,
    fill: "#ffa18b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.d6ac00a67c94f8f7afe7592073f67ca5.svg";
export { ForwardRef as ReactComponent };